import { IIconProps } from './icon';

export const IconSocioeconomic = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconSocioeconomic${cy}`}
    >
      <path
        d="M17.8125 30C22.4724 30 26.25 26.2224 26.25 21.5625C26.25 16.9026 22.4724 13.125 17.8125 13.125C13.1526 13.125 9.375 16.9026 9.375 21.5625C9.375 26.2224 13.1526 30 17.8125 30Z"
        fill="#793EAD"
      />
      <path
        d="M27.4219 34.6875C24.1219 33.0117 20.4797 32.3438 17.8125 32.3438C12.5883 32.3438 1.875 35.5477 1.875 41.9531V46.875H19.4531V44.9918C19.4531 42.7652 20.3906 40.5328 22.0312 38.6719C23.3402 37.1859 25.173 35.8066 27.4219 34.6875Z"
        fill="#793EAD"
      />
      <path
        d="M39.8438 33.75C33.7418 33.75 21.5625 37.5187 21.5625 45V50.625H58.125V45C58.125 37.5187 45.9457 33.75 39.8438 33.75Z"
        fill="#793EAD"
      />
      <path
        d="M39.8438 30C45.5392 30 50.1562 25.3829 50.1562 19.6875C50.1562 13.9921 45.5392 9.375 39.8438 9.375C34.1483 9.375 29.5312 13.9921 29.5312 19.6875C29.5312 25.3829 34.1483 30 39.8438 30Z"
        fill="#793EAD"
      />
    </svg>
  );
};
